<template lang="html">
  <d-input-group class="align-items-center">
    <masked-input
      type="text"
      :class="['col-10 form-control', className, 'is-' + state]"
      :id="id"
      :placeholder="placeholder"
      :mask="[/\d/, /\d/,'.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/]"
      :guide="false"
      v-model="number"
    ></masked-input>
    <d-input class="form-control input-group-text col-2" disabled value="SSP/" disable/>
    <d-form-input
        class="col-2"
        type="text"
        placeholder="XX"
        v-model="emitter"
    />
  </d-input-group>
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  name: 'InputGeneralRegister',
  components: {
    MaskedInput,
  },
  props: {
    placeholder: {
      type: String,
      default: '00.000.000-x',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    number: {
      get() {
        return this.getNumber();
      },
      set(val) {
        this.$emit('update:model', val.concat(' SSP/', this.emitter));
      },
    },
    emitter: {
      get() {
        return this.getEmitter();
      },
      set(val) {
        if (!val) val = 'SP';
        this.$emit('update:model', this.number.concat(' SSP/', val));
      },
    },
  },
  mounted() {
    this.phone = this.model;
  },
  methods: {
    join() {
      return this.number.concat(' SSP/SP', this.emitter);
    },
    getNumber() {
      return (this.model) ? this.model.split(' SSP/')[0] : null;
    },
    getEmitter() {
      return (this.model) ? this.model.split(' SSP/')[1] : 'SP';
    },
  },
};
</script>
